export default {"src":"/_next/static/media/financial-transactions.63abf82a.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};